import apiClient from '../core/apiClient';
import { API_CONFIG } from '../config/config';

const { USER } = API_CONFIG.ENDPOINTS;

export const userProfileService = {
  async getProfile() {
    const response = await apiClient.get(USER.PROFILE);
    return response.data;
  },
  async updateProfile(payload) {
    const response = await apiClient.put(USER.PROFILE, payload);
    return response.data;
  },
};

export default userProfileService;
